import { InMemoryCache } from '@apollo/client';

import { possibleTypes } from '../../graphql/gen/fragmentTypes.json';
import { Domain, LoggedInQuery } from '../../graphql/gen/types';

// TODO rename file

export function createCache(): InMemoryCache {
  return new InMemoryCache({
    possibleTypes,
    typePolicies: {
      Query: {
        fields: {
          loggedIn: {
            merge: (existing: LoggedInQuery, incoming: LoggedInQuery): LoggedInQuery => {
              return { ...existing, ...incoming };
            },
          },
        },
      },
      User: {
        fields: {
          domain: {
            merge: (existing: Domain, incoming: Domain): Domain => {
              return { ...existing, ...incoming };
            },
          },
        },
      },
    },
  });
}
